module.exports = __webpack_public_path__ + "static/media/invoice-1.f351e12c.svg";